// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__CalendarMonthYearPickerInput from "../../components/molecules/CalendarMonthYearPickerInput.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Dropdown from "../../components/html/Dropdown.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Tax from "../../grpc/Tax.js";
import * as Buhta_cabinet__TaxControl from "../../grpc/TaxControl.js";
import * as Buhta_cabinet__TaxPaymentsOrdersForm from "../../components/organisms/Taxes/PaymentsTaxes/TaxPaymentsOrdersForm.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Decimal from "../../../../../packages/util/lib/Decimal.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(className) {
  return function (setIsModalShown) {
    const match = React.useState(function () {
          return false;
        });
    const setIsDropdownShown = match[1];
    const activator = function (param) {
      return JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  src: StaticAsset.src("/static/icons/more-asphalt-20.svg")
                });
    };
    return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                className: className,
                innerClassName: "mt-1",
                align: "BottomLeft",
                activator: activator,
                background: "bg-white",
                isDropdownShown: match[0],
                setIsDropdownShown: setIsDropdownShown,
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("a", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Редактировать"
                                    }),
                                JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/edit-20.svg")
                                    })
                              ],
                              className: "flex justify-between px-4 hover:bg-gray-pale py-2",
                              onClick: (function (param) {
                                  Curry._1(setIsModalShown, (function (param) {
                                          return true;
                                        }));
                                  Curry._1(setIsDropdownShown, (function (param) {
                                          return false;
                                        }));
                                })
                            }),
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "text-alert",
                                      children: "Убрать из списка"
                                    }),
                                JsxRuntime.jsx("img", {
                                      className: "w-5 h-5 ",
                                      src: StaticAsset.src("/static/icons/close-red.svg")
                                    })
                              ],
                              className: "flex justify-between px-4 hover:bg-gray-pale py-2",
                              onClick: (function (param) {
                                  Curry._1(setIsDropdownShown, (function (param) {
                                          return false;
                                        }));
                                })
                            })
                      ],
                      className: "py-2 flex flex-col w-55"
                    }),
                activatorBg: true
              });
  };
}

function TaxPaymentsOrdersPage$EmployeeDropdown(Props) {
  return make(Props.className)(Props.setIsModalShown);
}

const EmployeeDropdown = {
  make: TaxPaymentsOrdersPage$EmployeeDropdown
};

function TaxPaymentsOrdersPage$NewEmployeeDropdown(Props) {
  const match = React.useState(function () {
        return false;
      });
  const setIsDropdownShown = match[1];
  const activator = function (param) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                        children: "Добавить сотрудника"
                      }),
                  JsxRuntime.jsx("img", {
                        className: "w-4 h-4 ml-2",
                        alt: "plus",
                        src: StaticAsset.src("/static/icons/plus-gray.svg")
                      })
                ],
                className: "flex items-center"
              });
  };
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
              className: "!static !pt-0",
              align: "Bottom",
              activator: activator,
              background: "bg-white mt-1",
              isDropdownShown: match[0],
              setIsDropdownShown: setIsDropdownShown,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "flex py-2 text-gray-medium px-4",
                            children: "Текущие сотрудники"
                          }),
                      JsxRuntime.jsxs("ul", {
                            children: [
                              JsxRuntime.jsx("li", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          children: "Төлеген Төлеби Арыстандыұлы"
                                        }),
                                    className: "flex px-4 hover:bg-gray-pale py-2",
                                    onClick: (function (param) {
                                        Curry._1(setIsDropdownShown, (function (param) {
                                                return false;
                                              }));
                                      })
                                  }),
                              JsxRuntime.jsx("li", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          children: "Нурпеисова Мадина Пархатовна"
                                        }),
                                    className: "flex hover:bg-gray-pale px-4 py-2",
                                    onClick: (function (param) {
                                        Curry._1(setIsDropdownShown, (function (param) {
                                                return false;
                                              }));
                                      })
                                  })
                            ]
                          }),
                      JsxRuntime.jsx("hr", {
                            className: "my-1 mx-2"
                          })
                    ],
                    className: "py-2 flex flex-col w-[255px]"
                  })
            });
}

const NewEmployeeDropdown = {
  make: TaxPaymentsOrdersPage$NewEmployeeDropdown
};

function TaxPaymentsOrdersPage(Props) {
  let org = Props.org;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = React.useState(function () {
        return false;
      });
  const reportBlanks = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setKogd = match$2[1];
  const match$3 = React.useState(function () {
        return false;
      });
  const setIsChiefModalShown = match$3[1];
  const isChiefModalShown = match$3[0];
  const match$4 = React.useState(function () {
        return false;
      });
  const setIsEmpModalShown = match$4[1];
  const isEmpModalShown = match$4[0];
  const currentDt = DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  const match$5 = React.useState(function () {
        return DateTime.year(currentDt);
      });
  const setPaymentYear = match$5[1];
  const paymentYear = match$5[0];
  const match$6 = React.useState(function () {
        return DateTime.previousMonth(currentDt);
      });
  const setPaymentMonth = match$6[1];
  const paymentMonth = match$6[0];
  const match$7 = React.useState(function () {
        return DateTime.toMonthYearFormat(DateTime.setLocale("ru", DateTime.local(paymentYear, paymentMonth, 1, undefined, undefined, undefined, undefined, undefined)));
      });
  const setPaymentDate = match$7[1];
  const paymentDate = match$7[0];
  const match$8 = React.useState(function () {
        return Curry._7(Buhta_cabinet__Tax.EmployeeInfo.make, undefined, undefined, undefined, undefined, "", undefined, undefined);
      });
  const setEmployeeInfo = match$8[1];
  const match$9 = React.useState(function () {
        return {
                hd: Curry.app(Buhta_cabinet__Tax.Earning.make, [
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      "",
                      undefined,
                      undefined,
                      undefined,
                      undefined
                    ]),
                tl: /* [] */0
              };
      });
  const setEmployeeEarnings = match$9[1];
  const arg = Curry._3(Buhta_cabinet__Tax.Period.make, paymentYear, {
        NAME: "Month",
        VAL: paymentMonth
      }, undefined);
  const arg$1 = reportBlanks;
  const func = Buhta_cabinet__Tax.PayrollTaxService.calculate;
  const match$10 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func, param, arg$1, arg);
        }), undefined);
  const dispatch = match$10[1];
  const model = match$10[0];
  React.useEffect((function () {
          Curry._2(dispatch, undefined, undefined);
        }), [
        paymentDate,
        reportBlanks
      ]);
  const func$1 = Buhta_cabinet__TaxControl.TaxInformationService.view;
  const match$11 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._2(func$1, param, /* [] */0);
        }), undefined);
  const dispatchOrg = match$11[1];
  const settingsOrg = match$11[0];
  React.useEffect((function () {
          Curry._2(dispatchOrg, undefined, undefined);
        }), []);
  React.useEffect((function () {
          if (typeof settingsOrg !== "string" && settingsOrg.NAME === "Data") {
            const settings = settingsOrg.VAL;
            Curry._1(setKogd, (function (param) {
                    return settings.kogd;
                  }));
          }
          
        }), [settingsOrg]);
  const emptyInfo = Curry._7(Buhta_cabinet__Tax.EmployeeInfo.make, undefined, undefined, undefined, undefined, "", undefined, undefined);
  const emptyEarnings = Curry.app(Buhta_cabinet__Tax.Earning.make, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        "",
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  const sumAmount = function (items) {
    return Belt__Belt_List.reduce(items, Decimal.make(0), (function (sum, item) {
                  const amount = item.amount;
                  if (amount !== undefined) {
                    return Decimal.plus(sum, Decimal.fromString(amount));
                  } else {
                    return sum;
                  }
                }));
  };
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Налоги за руководителя и сотрудников",
        route: contextRoute({
              TAG: /* Tax */4,
              _0: {
                TAG: /* Payments */0,
                _0: /* Index */0
              }
            })
      });
  let tmp;
  if (typeof model === "string") {
    tmp = model === "Loading" ? "Загрузка..." : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  } else if (model.NAME === "Data") {
    const item = model.VAL;
    const match$12 = item.chief;
    let chiefInfo;
    if (match$12 !== undefined) {
      const info = match$12.info;
      chiefInfo = info !== undefined ? info : emptyInfo;
    } else {
      chiefInfo = emptyInfo;
    }
    const match$13 = item.chief;
    const chiefEarnings = match$13 !== undefined ? match$13.earnings : ({
          hd: emptyEarnings,
          tl: /* [] */0
        });
    const name = chiefInfo.patronymic_name;
    const patronymic_name = name !== undefined ? name : "";
    const fullName = Stdlib__String.concat(" ", {
          hd: chiefInfo.family_name,
          tl: {
            hd: chiefInfo.given_name,
            tl: {
              hd: patronymic_name,
              tl: /* [] */0
            }
          }
        });
    const __x = item.employees;
    tmp = JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "ДАННЫЕ ПЛАТЕЖА"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__CalendarMonthYearPickerInput.make, {
                                          value: paymentDate,
                                          onPicked: (function (date) {
                                              Curry._1(setPaymentDate, (function (param) {
                                                      return DateTime.toMonthYearFormat(DateTime.setLocale("ru", date)).toUpperCase().substring(0, 1) + DateTime.toMonthYearFormat(DateTime.setLocale("ru", date)).slice(1, undefined);
                                                    }));
                                              const paymentDate = DateTime.toMonthYearFormat(date).toUpperCase().substring(0, 1) + DateTime.toMonthYearFormat(date).slice(1, undefined);
                                              Curry._1(setPaymentYear, (function (param) {
                                                      return DateTime.year(DateTime.fromFormat(paymentDate, "LLLL yyyy"));
                                                    }));
                                              Curry._1(setPaymentMonth, (function (param) {
                                                      return DateTime.month(DateTime.fromFormat(paymentDate, "LLLL yyyy"));
                                                    }));
                                            }),
                                          align: "BottomRight",
                                          className: "pt-1 w-full",
                                          label: "Период оплаты"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KogdSelect.make, {
                                          kogd: match$2[0],
                                          onKogdSelect: (function (value) {
                                              Curry._1(setKogd, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          label: "Налоговая по месту нахождения",
                                          className: "!mt-0"
                                        })
                                  ],
                                  className: "flex flex-col gap-4"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "РУКОВОДИТЕЛЬ ПРЕДПРИЯТИЯ"
                                        }),
                                    JsxRuntime.jsx("a", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                className: "!font-mediumbold mb-1",
                                                                children: fullName
                                                              }),
                                                          Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(chiefEarnings, (function (index, earning) {
                                                                      const payrollDeductions = sumAmount(earning.payroll_deductions);
                                                                      const payrollTaxes = sumAmount(earning.payroll_taxes);
                                                                      const totalAmount = Decimal.plus(payrollDeductions, payrollTaxes);
                                                                      const Key = String(index);
                                                                      return JsxRuntime.jsxs("div", {
                                                                                  children: [
                                                                                    JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                  className: "text-gray-medium",
                                                                                                  children: "Доход руководителя"
                                                                                                }),
                                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                  className: "font-mediumbold",
                                                                                                  children: MelNumeral.formatInt({
                                                                                                        NAME: "Str",
                                                                                                        VAL: earning.gross_income
                                                                                                      }) + " ₸"
                                                                                                })
                                                                                          ],
                                                                                          className: "flex gap-2"
                                                                                        }),
                                                                                    JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                  className: "text-gray-medium",
                                                                                                  children: "К оплате"
                                                                                                }),
                                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                  className: "font-mediumbold",
                                                                                                  children: MelNumeral.formatInt({
                                                                                                        NAME: "Str",
                                                                                                        VAL: Decimal.toString(totalAmount)
                                                                                                      }) + " ₸"
                                                                                                })
                                                                                          ],
                                                                                          className: "flex gap-2"
                                                                                        })
                                                                                  ]
                                                                                }, Key);
                                                                    })))
                                                        ],
                                                        className: "flex flex-col gap-1"
                                                      }),
                                                  JsxRuntime.jsx("img", {
                                                        className: "w-5 h-5",
                                                        alt: "more",
                                                        src: StaticAsset.src("/static/icons/arrow-right-16.svg")
                                                      })
                                                ],
                                                className: "flex items-center justify-between"
                                              }),
                                          className: "flex flex-col p-4 border border-gray-main rounded hover:bg-gray-pale",
                                          onClick: (function (param) {
                                              Curry._1(setIsChiefModalShown, (function (param) {
                                                      return true;
                                                    }));
                                            })
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold mt-2",
                                          children: "СОТРУДНИКИ"
                                        }),
                                    Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (i, emp) {
                                                const info = emp.info;
                                                const employeeInfo = info !== undefined ? info : emptyInfo;
                                                const name = employeeInfo.patronymic_name;
                                                const patronymic_name = name !== undefined ? name : "";
                                                const fullName = Stdlib__String.concat(" ", {
                                                      hd: employeeInfo.family_name,
                                                      tl: {
                                                        hd: employeeInfo.given_name,
                                                        tl: {
                                                          hd: patronymic_name,
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    });
                                                const Key = String(i);
                                                const __x = emp.earnings;
                                                return JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsxs("a", {
                                                                          children: [
                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                  className: "!font-mediumbold mb-1",
                                                                                  children: fullName
                                                                                }),
                                                                            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, earning) {
                                                                                        const payrollDeductions = sumAmount(earning.payroll_deductions);
                                                                                        const payrollTaxes = sumAmount(earning.payroll_taxes);
                                                                                        const totalAmount = Decimal.plus(payrollDeductions, payrollTaxes);
                                                                                        const concatedList = Belt__Belt_List.concat(earning.payroll_deductions, earning.payroll_taxes);
                                                                                        const Key = String(index);
                                                                                        return JsxRuntime.jsxs("div", {
                                                                                                    children: [
                                                                                                      JsxRuntime.jsxs("div", {
                                                                                                            children: [
                                                                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                                    className: "text-gray-medium",
                                                                                                                    children: "Зарплата"
                                                                                                                  }),
                                                                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                                    className: "font-mediumbold",
                                                                                                                    children: MelNumeral.formatInt({
                                                                                                                          NAME: "Str",
                                                                                                                          VAL: earning.gross_income
                                                                                                                        }) + " ₸"
                                                                                                                  })
                                                                                                            ],
                                                                                                            className: "flex gap-2"
                                                                                                          }),
                                                                                                      JsxRuntime.jsxs("div", {
                                                                                                            children: [
                                                                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                                    className: "text-gray-medium",
                                                                                                                    children: "К оплате"
                                                                                                                  }),
                                                                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                                    className: "font-mediumbold",
                                                                                                                    children: MelNumeral.formatInt({
                                                                                                                          NAME: "Str",
                                                                                                                          VAL: Decimal.toString(totalAmount)
                                                                                                                        }) + " ₸"
                                                                                                                  }),
                                                                                                              Belt__Belt_List.has(concatedList, index, (function (item, param) {
                                                                                                                      return item.exempt;
                                                                                                                    })) ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                                                      className: "font-mediumbold text-success",
                                                                                                                      children: "Частично освобожден"
                                                                                                                    }) : null
                                                                                                            ],
                                                                                                            className: "flex gap-2"
                                                                                                          })
                                                                                                    ]
                                                                                                  }, Key);
                                                                                      })))
                                                                          ],
                                                                          className: "flex flex-col gap-1 py-4 pl-4 hover:bg-gray-pale w-[430px]",
                                                                          onClick: (function (param) {
                                                                              Curry._1(setIsEmpModalShown, (function (param) {
                                                                                      return true;
                                                                                    }));
                                                                              Curry._1(setEmployeeInfo, (function (param) {
                                                                                      return employeeInfo;
                                                                                    }));
                                                                              Curry._1(setEmployeeEarnings, (function (param) {
                                                                                      return emp.earnings;
                                                                                    }));
                                                                            })
                                                                        }),
                                                                    JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx(TaxPaymentsOrdersPage$EmployeeDropdown, {
                                                                                className: "hover:bg-gray-pale !pt-0 hover:rounded-sm",
                                                                                setIsModalShown: setIsEmpModalShown
                                                                              }),
                                                                          className: "h-[104px] px-4 flex justify-center items-center"
                                                                        })
                                                                  ],
                                                                  className: "flex items-center justify-between"
                                                                }),
                                                            className: "flex flex-col border border-gray-main rounded "
                                                          }, Key);
                                              })))
                                  ],
                                  className: "flex flex-col gap-4"
                                })
                          ],
                          className: "flex flex-col gap-6 p-10"
                        }),
                    isEmpModalShown ? JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersForm.make, {
                            isDirector: false,
                            info: match$8[0],
                            earnings: match$9[0],
                            isModalShown: isEmpModalShown,
                            setIsModalShown: setIsEmpModalShown
                          }) : (
                        isChiefModalShown ? JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersForm.make, {
                                isDirector: true,
                                info: chiefInfo,
                                earnings: chiefEarnings,
                                isModalShown: isChiefModalShown,
                                setIsModalShown: setIsChiefModalShown,
                                setReportBlanks: match$1[1]
                              }) : null
                      )
                  ],
                  className: "bg-white w-[562px] rounded-md"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                        title: "Сформировать",
                        className: "px-6 py-3",
                        type_: "submit"
                      }),
                  className: "w-[562px] flex justify-end mt-6"
                })
          ]
        });
  } else {
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: tmp,
              className: "bg-gray-pale py-10 flex-col items-center"
            });
}

const make$1 = TaxPaymentsOrdersPage;

export {
  EmployeeDropdown ,
  NewEmployeeDropdown ,
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
